import React from 'react';
import { render } from 'react-dom';
import './fetch';
import App from './App';
import './styles';
import moment from 'moment';

require('moment/locale/fr');
moment.locale('fr');

render(<App />, document.getElementById('myApp'));
